import { utilsModule } from "../utils-module";
/**
 * @file
 * @name cpfCnpjFilters
 * @description
 * 
 * IDHA TECNOLOGIA
 * 
 * Nome do arquivo: 'cpfCnpjFilters'
 * Criação: 09/05/2018
 * 
 * Descrição:
 * 
 * Filtros para manipulação de CPF e CNPJ
 * 
 * 
 * @author William Azevedo de Paula
 */

/**
 * @private
 * @name cpfCnpjFilters#cpfFilter
 * @method
 * @methodOf cpfCnpjFilters
 * @description
 * Formata um texto como cpf
 * @param {string} cpf cpf a ser formatado
 * @returns {string} o cpf com a mascara 999.999.999-99, ou '' caso não haja 11 caracteres
 */
let cpfFilter = (cpf:string):string=>{
    if(!cpf) return '';
    //@TODO: verificar se é melhor retornar nulo ou disparar excessão
    if(cpf.length < 11) return cpf;

    return `${cpf.slice(0,3)}.${cpf.slice(3,6)}.${cpf.slice(6,9)}-${cpf.slice(9,11)}`;
}
/**
 * @private
 * @name cpfCnpjFilters#cnpjFilter
 * @method
 * @methodOf cpfCnpjFilters
 * @description
 * Formata um texto como cnpj
 * @param {string} cnpj cnpj a ser formatado
 * @returns {string} o cnpj com a mascara 99.999.999/9999-99, ou '' caso não haja 14 caracteres
 */
let cnpjFilter = (cnpj:string):string=>{
    if(!cnpj) return '';
        //@TODO: verificar se é melhor retornar nulo ou disparar excessão
        if(cnpj.length < 14) return cnpj;

		return `${cnpj.slice(0,2)}.${cnpj.slice(2,5)}.${cnpj.slice(5,8)}/${cnpj.slice(8,12)}-${cnpj.slice(12,14)}`;
}


/**
 * @public
 * @ngdoc filter
 * @name cpfCnpjFilters.filter:cpfFilter
 * @see cpfCnpjFilters#cpfFilter
 * @description
 * 
 * Filtro para aplicar máscara de cpf
 * @param {string} cpf a ser formatado
 * @returns {string} o cpf com a mascara 99.999.999/9999-99, ou '' caso não haja 14 caracteres
 */
utilsModule.filter('cpf', [function(){
	return cpfFilter;
}]);
/**
 * @public
 * @ngdoc filter
 * @name cpfCnpjFilters.filter:cnpjFilter 
 * @see cpfCnpjFilters#cnpjFilter
 * @description
 * 
 * Filtro para formatar um texto como cnpj
 * @param {string} cnpj cnpj a ser formatado
 * @returns {string} o cnpj com a mascara 99.999.999/9999-99, ou '' caso não haja 14 caracteres
 */
utilsModule.filter('cnpj', [function(){
	return cnpjFilter;
}]);
/**
 * @public
 * @ngdoc filter
 * @name cpfCnpjFilters.filter:cpfOrCnpjFilter 
 * @see cpfCnpjFilters#cpfFilter
 * @see cpfCnpjFilters#cnpjFilter
 * @description
 * 
 * Filtro para formatar um texto como cpf ou cnpj, identificando o formato correto
 * conforme o tamanho da entrada (11 caracteres => cpf; 14 caracteres => cnpj)
 * @param {string} reg o registro a ser formatado como cpf ou cnpj
 * @returns {string} o teto formatado
 */
utilsModule.filter('cpfOrCnpj', [function(){
	return function(reg:string){
		if(!reg) return '';

        if(reg.length == 11){
            return cpfFilter(reg);
        }else if(reg.length == 14){
            return cnpjFilter(reg);
        }
	};
}]);